import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { fetchCategories, ICategory } from "../lib/feed-api";
import { useCategoryStore } from "../stores/use-tutorial-progress";
import { useUser } from "@supabase/auth-helpers-react";

export const useLoadCategories = () => {
  const setCategories = useCategoryStore((state) => state.setCategories);
  const user = useUser();
  const {
    data: categories,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['categories'],
    queryFn: async () => fetchCategories(user.id),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });
  
  useEffect(() => {
    if (categories) {
      setCategories(categories);
    }
  }, [categories, setCategories]);

  return {
    categories: categories || [],
    isLoading,
    error,
  };
};